// extracted by mini-css-extract-plugin
export var actions = "_1n-0";
export var actionsContainer = "_1n-7";
export var border = "_1n-1";
export var childFullHeight = "_1n-e";
export var collapse = "_1n-2";
export var content = "_1n-9";
export var contentChild = "_1n-d";
export var fullscreen = "_1n-b";
export var hasLeftRadius = "_1n-j";
export var headerContainer = "_1n-3";
export var headerRow = "_1n-5";
export var hidePadding = "_1n-a";
export var navCollapsedGap = "_1n-k";
export var noScrollX = "_1n-l";
export var noScrollY = "_1n-m";
export var noTopPadding = "_1n-h";
export var optOutTopPadding = "_1n-c";
export var pageMain = "_1n-i";
export var pageOuter = "_1n-f";
export var pagePadding = "_1n-8";
export var profile = "_1n-n";
export var profileContainer = "_1n-o";
export var profileImage = "_1n-p";
export var profileMain = "_1n-q";
export var profileSubtitle = "_1n-s";
export var profileTitle = "_1n-r";
export var showLeftPadding = "_1n-g";
export var tabsPortalSlot = "_1n-6";
export var tabsWrapper = "_1n-4";
export var title = "_1n-t";